import { apiService, fetchingAPI } from '@/api'
import { toast } from '@/components/toasts/toast.helpers'

// Authorization is server-side (authorize_webhook_editor); nothing here is a gate.
//
// Org never goes in the body: there, a webhook-editor could name another org. The
// organizationid HEADER stays the caller's own because that authenticates them; the query
// param is the org acted on.
const WEBHOOK_BASE = () => `${apiService.eventDelivery}/api/webhook_subscriptions`
const USE_OWN_ORG = true

const withOrg = (path, organizationId) => {
  const separator = path.includes('?') ? '&' : '?'
  return `${WEBHOOK_BASE()}${path}${separator}requested_organization_id=${organizationId}`
}

// 404 is a normal state here, so it becomes null. Other errors propagate: "none yet"
// must stay distinct from "load failed", else a failed load looks like create mode and
// invites a duplicate 409.
export const fetchWebhookSubscription =
  ({ organizationId }) =>
  async (dispatch) => {
    try {
      return await fetchingAPI(
        withOrg('/', organizationId),
        'GET',
        dispatch,
        undefined,
        undefined,
        {},
        USE_OWN_ORG
      )
    } catch (error) {
      if (error?.status === 404) {
        return null
      }
      throw error
    }
  }

// Only time signing_secret is ever visible — stored encrypted after. Callers must
// surface it, not drop it.
export const createWebhookSubscription =
  ({ organizationId, url, eventTypes, active }) =>
  async (dispatch) => {
    try {
      const created = await fetchingAPI(
        withOrg('/', organizationId),
        'POST',
        dispatch,
        JSON.stringify({ url, event_types: eventTypes, active }),
        undefined,
        {},
        USE_OWN_ORG
      )
      toast.success('Webhook created')
      return created
    } catch (error) {
      toast.error(error?.message || 'Failed to create webhook')
      return null
    }
  }

export const updateWebhookSubscription =
  ({ organizationId, patch, successMessage }) =>
  async (dispatch) => {
    try {
      const updated = await fetchingAPI(
        withOrg('/', organizationId),
        'PATCH',
        dispatch,
        JSON.stringify(patch),
        undefined,
        {},
        USE_OWN_ORG
      )
      toast.success(successMessage || 'Webhook updated')
      return updated
    } catch (error) {
      toast.error(error?.message || 'Failed to update webhook')
      return null
    }
  }

export const rotateWebhookSecret =
  ({ organizationId }) =>
  async (dispatch) => {
    try {
      const rotated = await fetchingAPI(
        withOrg('/rotate_secret', organizationId),
        'POST',
        dispatch,
        undefined,
        undefined,
        {},
        USE_OWN_ORG
      )
      toast.success('Signing secret rotated')
      return rotated
    } catch (error) {
      toast.error(error?.message || 'Failed to rotate signing secret')
      return null
    }
  }
